import { IRequestByPartnerId } from 'legacy/lut/classes/models/service'
import { PartnerPageMetric } from 'legacy/lut/configs/metrics'
import { fetchPartnerRequestById } from 'legacy/lut/services/partner/fetchPartnerRequestById'
import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'

import { selectUser } from 'core-components/sitebuilder/store/selectors/selectUser'
import { measureRequest } from 'shared/lib/metrics'

import { GET_PARTNER_BY_ID_REQUEST } from '../configs'

export const getPartnerById = createAsyncThunk(
  GET_PARTNER_BY_ID_REQUEST,
  async ({ partnerId, options }: IRequestByPartnerId, { getState }) =>
    measureRequest(PartnerPageMetric.Partner, selectUser(getState()), () =>
      fetchPartnerRequestById(partnerId, options)
    )
)
